import React from 'react'

export default function About(props) {
  return (
    <div className="accordion" id="accordionExample">
  <div className="accordion-item" style={{backgroundColor:props.mode==='light'?'white':'#2a2f33'}}>
    <h2 className="accordion-header">
      <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
        About US
      </button>
    </h2>
    <div id="collapseOne" className="accordion-collapse collapse show" data-bs-parent="#accordionExample">
      <div className="accordion-body"  style={{color:props.mode==='light'?'black':'white'}}>
        <strong>👋 Welcome to TextUtils — your smart, no-fuss companion for fast and efficient text editing! Whether you're fine-tuning reports, drafting emails, or formatting text for presentations, TextUtils helps busy professionals get it done quicker. Convert your content to UPPERCASE 🔠, lowercase 🔡, or clean up extra spaces 🧹 — all in just one click.
        <br /><br /><br />
        🗣️ Want to hear your text read out loud? We've got you covered with our text-to-speech feature — perfect for quick reviews or multitasking. Need to copy ✂️ or clear 🗑️ your content? That’s instant too. Plus, you'll get live stats including word count 📄, character count ✍️, and even an estimated reading time ⏱️, along with a live preview window 🔍 to see your edits as you go.
        <br /><br /><br />
        💡 And the best part? TextUtils is 100% free and open source 🆓🛠️. No sign-ups, no installs — just open your browser and go. It’s built to save time and keep your work clean, clear, and professional. TextUtils is the perfect everyday tool to power up your writing workflow! 🚀
        </strong>
      </div>
    </div>
  </div>
  </div>
  )
}
